// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__dVw6m","title":"styles_title__wpgrY","content":"styles_content__zrRH2","progress":"styles_progress__vbIoi"};